import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { FilePreviewPage } from './file-preview';

@NgModule({
    declarations: [
        FilePreviewPage,
    ],
    imports: [
        IonicPageModule.forChild(FilePreviewPage),
    ],
})
export class FilePreviewPageModule { }


// WEBPACK FOOTER //
// ./src/pages/docren/file-preview.module.ts